import { PersistentSessionsManager } from './PersistentSessionsManager';
import { VolatileSessionsManager } from './VolatileSessionManager';
export function getSessionManagerByConfig(sessionTrackingConfig) {
    return (sessionTrackingConfig === null || sessionTrackingConfig === void 0 ? void 0 : sessionTrackingConfig.persistent) ? PersistentSessionsManager : VolatileSessionsManager;
}
